import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

/**
 * Product status with appropriate color
 */
export const ProductStatusText = (props) => {
    const { t } = useTranslation();
    const { status_name_eng } = props.status;
    const statusText = t(`products.status.${status_name_eng}`);

    const colors = {
        Available: "#068e06",
        "Initial reservation": "#052cbb",
        Reservation: "#00b2ff",
        "Fictional reservation": "#8c00ff",
        Sold: "#FF0000",
    };

    if (!(status_name_eng in colors)) {
        return (
            // Default color
            <Typography>{statusText}</Typography>
        );
    }

    return <Typography color={colors[status_name_eng]}>{statusText}</Typography>;
};
